import React from 'react';
import { Link } from 'react-router-dom';

const TermsPage = () => {
    return (
        <div className="container py-5">
            <div className="row justify-content-center">
                <div className="col-lg-8">
                    <div className="card shadow-sm">
                        <div className="card-body p-5">
                            <h1 className="mb-4">Términos y Condiciones</h1>
                            <p className="text-muted mb-5">Última actualización: {new Date().toLocaleDateString()}</p>

                            <section className="mb-5">
                                <h4>1. Introducción</h4>
                                <p>
                                    Bienvenido a CUDA. Al utilizar nuestros servicios, usted acepta estar legalmente vinculado por estos términos.
                                    Nuestro servicio consiste en un asistente virtual basado en inteligencia artificial integrado con Telegram.
                                </p>
                            </section>

                            <section className="mb-5">
                                <h4>2. Planes y Suscripciones</h4>
                                <p>Ofrecemos los siguientes niveles de servicio:</p>
                                <ul>
                                    <li><strong>Plan Free (Gratuito):</strong> Incluye 20 mensajes mensuales. No incluye recordatorios proactivos.</li>
                                    <li><strong>Plan Medio ($5/mes):</strong> Incluye 35 mensajes mensuales y acceso a recordatorios.</li>
                                    <li><strong>Plan Full ($10/mes):</strong> Mensajes ilimitados, recordatorios y soporte prioritario.</li>
                                    <li><strong>Plan Trial (Prueba):</strong> Acceso ilimitado por 15 días al registrarse.</li>
                                    <li><strong>Plan VIP:</strong> Acceso especial otorgado por administración.</li>
                                </ul>
                            </section>

                            <section className="mb-5">
                                <h4>3. Pagos y Facturación</h4>
                                <p>
                                    Los pagos se procesan de forma segura a través de <strong>PayPal</strong>.
                                    Aceptamos tarjetas de crédito y débito estén o no vinculadas a PayPal.
                                    Si usted posee una cuenta de PayPal, puede utilizarla para efectuar el pago.
                                    La suscripción se renueva automáticamente cada mes a menos que sea cancelada.
                                </p>
                            </section>

                            <section className="mb-5">
                                <h4>4. Cancelación y Reembolsos</h4>
                                <p>
                                    Puede cancelar su suscripción en cualquier momento desde su Dashboard.
                                    La cancelación se hará efectiva al finalizar el ciclo de facturación actual.
                                    No ofrecemos reembolsos por períodos parciales no utilizados.
                                </p>
                            </section>

                            <section className="mb-5">
                                <h4>5. Uso Aceptable</h4>
                                <p>
                                    Usted se compromete a no utilizar el servicio para actividades ilegales, spam o acoso.
                                    Nos reservamos el derecho de suspender cuentas que violen esta política.
                                </p>
                            </section>

                            <div className="mt-5 text-center">
                                <Link to="/register" className="btn btn-primary">Volver al Registro</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsPage;
